var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu',{attrs:{"showSubMenu":false}}),_c('div',{staticClass:"cant"},[_c('div',{staticClass:"heading-cant"},[_c('app-heading',{attrs:{"level":"h3"}},[_vm._v(_vm._s(_vm.$t('http.you_cant')))]),_c('i',{staticClass:"material-icons block-icon"},[_vm._v("block")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }